module.exports = __webpack_public_path__ + "img/mp.7cda8917.png";